import React from "react";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import ImageIcon from "@mui/icons-material/Image";

interface TableToggleViewProps {
  viewMode: "table" | "icon";
  onViewModeChange: (mode: "table" | "icon") => void;
}

const TableToggleView: React.FC<TableToggleViewProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="flex h-[38px] w-full items-center rounded-lg bg-[#2F5BEA] p-1 shadow-inner">
      {/* Table Option */}
      <button
        type="button"
        onClick={() => onViewModeChange("table")}
        className={`flex h-[30px] flex-1 items-center justify-center gap-1.5 rounded-md px-2 text-xs sm:text-sm font-medium transition-all ${
          viewMode === "table" ? "bg-white text-[#2F5BEA] shadow-sm" : "bg-transparent text-white hover:bg-white/10"
        }`}
      >
        <TableRestaurantIcon fontSize="small" />
        <span>Table</span>
      </button>

      {/* Icon Option */}
      <button
        type="button"
        onClick={() => onViewModeChange("icon")}
        className={`flex h-[30px] flex-1 items-center justify-center gap-1.5 rounded-md px-2 text-xs sm:text-sm font-medium transition-all ${
          viewMode === "icon" ? "bg-white text-[#2F5BEA] shadow-sm" : "bg-transparent text-white hover:bg-white/10"
        }`}
      >
        <ImageIcon fontSize="small" />
        <span>Icon</span>
      </button>
    </div>
  );
};

export default TableToggleView;
